import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { selectStyle } from "Redux/appSlice";
import { useAppSelector } from "Redux/hooks";
import { useRef } from "react";
import RichTextReader from "./RichTextReader";

type Props = {
  label?: any;
  id?: string;
  className?: string;
  onClick: (id: string) => void;
  selected?: boolean;
  type?: string;
  single?: boolean;
  setTerms: (id: string) => void;
};

// @function ModuleQuestion
// Render a ModuleQuestion button
// @param {string} label
// @param {string} id
// @param {string} className
// @param {function} onClick
// @param {boolean} selected
// @param {React.Node} children
// @returns {React.Node}
export default function ModuleQuestion({
  label = [],
  id = "",
  className = "",
  onClick,
  selected = false,
  type = "single",
  single = false,
  setTerms,
}: Props) {
  // TODO: Change with redux colors later on;
  // TODO: Change the tick mark (img_element) font for a better and bolder tick mark;
  // TODO: Find a neat way to implement event styling in jsx style

  const imageRef = useRef<HTMLImageElement>(null);
  const { color2 } = useAppSelector(selectStyle);

  const colouring = {
    selector: {
      active: color2,
      inactive: "#333333",
      background: {
        active: "#696969",
        inactive: "#696969",
      },
    },
    border: {
      regular: "#696969",
      hover: "#696969",
      active: "#696969",
    },
    color: {
      regular: "#696969",
      hover: "#696969",
      active: "#696969",
    },
  };
  const rootElement = {
    className: `w-full h-fit  min-h-14 w-full flex direction-col border-2  rounded-4xl relative ${className}`,
    styles: {
      borderColor: "#A6A6A6",
    },
  };
  const imgElement = {
    styles: {
      notSelected: {
        backgroundColor: "transparent",
        color: colouring.selector.inactive,
        transition: "0.2s ease-in-out",
      },
      selected: {
        backgroundColor: colouring.selector.active,
        color: colouring.selector.active,
      },
    },
  };

  return (
    <div id={id} className={rootElement.className} style={rootElement.styles}>
      <div
        className="absolute left-3.5 top-4 h-5 w-5 cursor-pointer rounded-full text-center font-black leading-5 ease-in "
        style={
          selected ? imgElement.styles.selected : imgElement.styles.notSelected
        }
        ref={imageRef}
        onMouseOver={() => {
          if (imageRef.current) {
            imageRef.current.style.background = color2;
          }
        }}
        onMouseOut={() => {
          if (imageRef.current && !selected) {
            imageRef.current.style.background = "transparent";
          }
        }}
      >
        {type === "single" || single ? (
          <FontAwesomeIcon
            icon={faCircleCheck}
            size="2x"
            className="absolute -left-[8px] -top-[8px]  "
            color="#A6A6A6"
            // TODO: check if this is correct, it was previously onClick={id => onClick(id)}
            onClick={(event) => onClick(event.currentTarget.id)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faCircle}
            size="2x"
            className="absolute -left-[6px] -top-[6px]  "
            color="#A6A6A6"
            // TODO: check if this is correct, it was previously onClick={id => onClick(id)}
            onClick={(event) => onClick(event.currentTarget.id)}
          />
        )}
      </div>{" "}
      <div
        style={{
          color: colouring.color.regular,
        }}
        className="pl-12   leading-5"
      >
        <RichTextReader
          text={label}
          size={"1.25em"}
          setTerms={(id) => {
            setTerms(id);
          }}
        />
      </div>
    </div>
  );
}
